(function($) {
    "use strict";

	var bodyEl = $('body'),
		openbtn = $('#open-menu-btn'),
		closebtn = $('#close-menu-btn'),
		isOpen = false,
		morphEl = $('#morph-shape')[0],

		s = Snap($(morphEl).find('svg')[0]),
		path = s.select('path'),
		starterPath = $('.morph-shape svg path').attr('d'),
		steps = $(morphEl).attr('data-morph-open').split(';'),
		stepsTotal = steps.length,
		isAnimating = false;

	function initElasticMenu() {
		openbtn.on('click', toggleMenu);
		if (closebtn) {
			closebtn.on('click', toggleMenu);
		}
	}

	function toggleMenu() {
		if (isAnimating) {
			return false;
		}

		isAnimating = true;
		if (isOpen) {
		    bodyEl.removeClass('show-menu');
			// animate path
			setTimeout(function () {
				// reset path
				$('.morph-shape svg path').attr('d', starterPath);
				isAnimating = false;
			}, 300);

		} else {
		    bodyEl.addClass('show-menu');
			// animate path
			var pos = 0,
				nextStep = function (pos) {
					if (pos > stepsTotal - 1) {
						isAnimating = false;
						return;
					}
					path.animate({ 'path': steps[pos] }, pos === 0 ? 400 : 500, pos === 0 ? mina.easein : mina.elastic, function () { nextStep(pos); });
					pos++;
				};
			nextStep(pos);
		}
		isOpen = !isOpen;
	}

    $(function() {
		initElasticMenu();
    });
})(jQuery);